import FOPaccounts from './views/fop-accounts.c';
export default FOPaccounts;
